import axios from "axios";
import { priceCheckURL } from "utils/constants";

function latestAsync(fn) {
    let lastCall = 0;

    return (...args) => {
        const callId = ++lastCall;

        return new Promise((resolve, reject) => {
            fn(...args)
                .then((result) => {
                    if (callId === lastCall) {
                        resolve(result);
                    }
                })
                .catch((error) => {
                    if (callId === lastCall) {
                        reject(error);
                    }
                });
        });
    };
}

const fetchCalculator = async (items) => {
    try {
        const query = Object.entries(items).map((item) => item.join("=")).join("&");
        const response = await axios.get(`${priceCheckURL}?${query}`);
        return response;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        return { data: { error: "Missing parameters" } };
    }
};

const calculatePrice = latestAsync(async (items) => {
    const calculatedResponse = await fetchCalculator(items);
    return calculatedResponse?.data;
});

export default calculatePrice;
